

export const mapAccessToken = process.env.REACT_APP_MAP_ACCESS_TOKEN;

//fetch weather data from Weather.com's API
export const weatherApiKey = process.env.REACT_APP_WEATHER_API_KEY;
export const weatherTileServerUrl = `https://api.weather.com/v3/TileServer/series/productSet/PPAcore?apiKey=${weatherApiKey}`;